import React from 'react';
import styles from './RoadMap.module.scss';
import { Row, Col } from 'reactstrap';
import { Animated } from 'react-animated-css';

const RoadMap = ({ isJoinPage = false }) => {
  return (
    <div className={styles.main_road_map} id='roadmaps'>
      <Row>
        <Col sm={12} md={12}>
          <Animated
            animationIn='animate__fadeInUp'
            animationOut='animate__fadeInUp'
            isVisible={true}
          >
            <div className={styles.road_map_head}>
              <h2>ROADMAP</h2>
              <h1>ROADMAP</h1>
            </div>
          </Animated>
        </Col>
        {isJoinPage ? (
          <Col sm={12} md={12}>
            <div className={styles.btn}>
              <button className={styles.discordBtn}>
                <a href='https://twitter.com/MutantApeBC_'><span>FOLLOW TWITTER</span></a>
              </button>
            </div>
          </Col>
        ) : null}
        <Col xs={2} sm={2} md={2}>
          {/* <div className={styles.circle}></div> */}
          <div className={styles.line}>
            <div className={styles.dottedline}></div>
          </div>
        </Col>
        <Col xs={10} sm={10} md={10}>
          <Animated
            animationIn='animate__fadeInUp'
            animationOut='animate__fadeInUp'
            isVisible={true}
          >
            <div className={styles.road_map_content}>
              <div className={styles.circle}>
                <div className={styles.circle_inner}></div>
              </div>
              <div>
                <h1>Phase 01</h1>
              </div><br/>
              <div>
                <h2>Foundation and Community Building</h2>
              </div>
              <div>
                <p>
                  <b>Launch and Distribution:</b> Launch the MutantApeBaseClub NFT project, 
                  introducing the unique Mutant Ape collectibles to the market. 
                  Conduct a fair and transparent distribution process to ensure broad participation and community ownership.<br/>
                  </p>

                 <p> 
                  <b>Community Engagement:</b> Foster an active and engaged community by organizing events, competitions, and giveaways. 
                  Encourage community members to share their Mutant Ape collections, artwork, and ideas. Establish communication channels, 
                  such as forums and social media platforms, for open dialogue and feedback.<br/>
                  </p>

                  <p>
                  <b>Token Utility Design:</b> Develop a comprehensive plan for the native token of the MutantApeBaseClub project. 
                  Define its utility within the ecosystem, such as governance rights, staking mechanisms, or access to exclusive features. 
                  Involve the community in the token design process to ensure alignment with their needs and aspirations.
                </p>
              </div>
              <div className={styles.circle}>
                <div className={styles.circle_inner}></div>
              </div>
              <div>
                <h1>Phase 02</h1>
              </div><br/>
              <div>
                <h2>Ecosystem Development</h2>
              </div>
              <div>
                <p>
                 <b>Marketplace Integration:</b> Collaborate with established NFT marketplaces to enable seamless buying, selling, and trading of 
                 Mutant Ape NFTs using the native token. Integrate features like royalty distribution to artists and collectors.<br/>
                 </p>

                 <p>
                 <b>Partnerships and Collaborations:</b> Forge strategic partnerships with other NFT projects, artists, and influencers to expand 
                 the reach and visibility of Mutant Ape NFTs. Collaborate on limited-edition collaborations or cross-project events to create unique and highly sought-after collectibles.<br/>
                 </p>

                 <p>
                 <b>Artist Support and Development:</b> Invest in the growth and development of artists within the MutantApeBaseClub community.
                  Establish grants, mentorship programs, and educational initiatives to nurture emerging talent and encourage innovation in digital art creation.
                </p>
              </div>
              <div className={styles.circle}>
                <div className={styles.circle_inner}></div>
              </div>
              <div>
                <h1>Phase 03</h1>
              </div><br/>
              <div>
                <h2>Governance and Expansion</h2>
              </div>
              <div>
                <p>
                  <b>Decentralized Governance:</b> Implement a decentralized governance framework that empowers token holders to participate in decision-making processes. 
                  Enable voting on key project proposals, such as artwork curation, marketplace integrations, and future development directions.<br/>
                  </p>

                  <p>
                  <b>Ecosystem Expansion:</b> Explore opportunities to expand the MutantApeBaseClub ecosystem beyond NFTs. Consider collaborations with gaming platforms, 
                  virtual worlds, or metaverses to integrate Mutant Ape NFTs and enhance their utility and value.<br/>
                  </p>

                  <p>
                  <b>Community Rewards and Incentives:</b> Design reward mechanisms to incentivize active participation and contribution within the MutantApeBaseClub community.
                   Reward token holders with exclusive perks, early access to new releases, or a share of the project's revenue.
                  into the foundation.
                </p>
              </div>
              <div className={styles.circle}>
                <div className={styles.circle_inner}></div>
              </div>
              <div>
                <h1>Phase 04</h1>
              </div><br/>
              <div>
                <h2>Long-Term Sustainability</h2>
              </div>
              <div>
                <p>
                  <b>Continued Development and Innovation:</b> Maintain a strong focus on ongoing development, upgrades, 
                  and innovation to ensure the longevity and relevance of the MutantApeBaseClub project. 
                  Regularly introduce new features, collaborations, and events to keep the community engaged and excited.
                </p>
                <p>
                  <b>Adoption and Integration:</b> Seek widespread adoption of Mutant Ape Base Club NFTs and the native token by exploring 
                  partnerships with mainstream brands, platforms, or organizations. Foster integration with existing ecosystems 
                  to increase the visibility and utility of the Mutant Ape NFTs.
                </p>
                <p>
                  <b>Community Empowerment:</b> Empower the community to take an active role in shaping the future of the MutantApeBaseClub project.
                  Provide opportunities for community-led initiatives, grants, and collaborations, allowing members to contribute to the growth and success of the project.
                </p>
              </div>
            </div>
          </Animated>
        </Col>
      </Row>
    </div>
  );
};

export default RoadMap;
